<template>
  <div class="menu_drawer" v-if="navigationOptions">
    <v-navigation-drawer
      location="right"
      temporary
      v-model="drawer"
      width="300"
      class="px-5 pt-4 cart-drawer"
    >
      <v-card class="px-0" elevation="0">
        <v-card-title
          class="tit pl-2 pr-2 d-flex justify-space-between align-center w-100"
          style="font-size: 17px; font-weight: bold"
        >
          <v-icon @click="drawer = false">mdi-close</v-icon>القائمة المتجر
        </v-card-title>

        <!-- Search Bar Section -->
        <div class="d-flex align-center mt-3 mb-3">
          <input
            v-model="searchQuery"
            type="search"
            :placeholder="placeholderText"
            class="search-input"
            @keyup.enter="redirectToSearch"
            style="
              flex: 1;
              height: 40px;
              border-radius: 20px;
              border: 1px solid #e9e9e9;
              outline: none;
              padding: 0 10px;
            "
          />
          <v-icon
            @click="redirectToSearch"
            style="cursor: pointer; margin-left: 5px"
          >
            mdi-magnify
          </v-icon>
        </div>

        <v-list>
          <v-list-item
            v-for="cat in categories"
            :key="cat.route"
            @click="
              $router.push({
                name: 'products_category',
                query: { category: cat.route, title: cat.title },
              })
            "
          >
            <v-list-item-title class="tit" dir="rtl">{{
              cat.title
            }}</v-list-item-title>
          </v-list-item>
        </v-list>
      </v-card>
    </v-navigation-drawer>
  </div>
</template>
<script>
import { useProductsModule } from "@/stores/products";
import { mapState } from "pinia";
import { ref, onMounted, computed, onBeforeUnmount, watch } from "vue"; // Import watch
import { useRouter, useRoute } from "vue-router"; // Import useRouter and useRoute

export default {
  inject: ["Emitter"],

  computed: {
    ...mapState(useProductsModule, ["categories"]),
  },

  data() {
    return {
      drawer: false,
    };
  },
  mounted() {
    this.Emitter.on("openMenu", () => {
      this.drawer = true;
    });
  },
  setup() {
    const router = useRouter(); // Initialize router
    const route = useRoute(); // Get the current route
    const searchQuery = ref(""); // Reactive search query
    const placeholderText = ref("البحث عن المنتجات..."); // Define placeholder text

    const redirectToSearch = () => {
      if (searchQuery.value.trim()) {
        // Ensure no empty query
        // Redirect to the search results page with the query
        router.push({
          name: "searchResults",
          query: { q: searchQuery.value.trim() },
        });
      }
    };

    const windowWidth = ref(window.innerWidth); // Reactive windowWidth

    const handleResize = () => {
      windowWidth.value = window.innerWidth; // Update the reactive width
    };

    // Watch for changes in the route to clear the search query when navigating away from search results
    watch(
      () => route.name,
      (newValue) => {
        if (newValue !== "searchResults") {
          searchQuery.value = ""; // Clear search query
        }
      },
      { immediate: true } // Ensures it runs on initial mount
    );

    // Add the resize listener when component is mounted
    onMounted(() => {
      window.addEventListener("resize", handleResize); // Add event listener for resizing
    });

    // Clean up the resize listener before the component is unmounted
    onBeforeUnmount(() => {
      window.removeEventListener("resize", handleResize); // Clean up the event listener
    });

    // Computed property for navigation options
    const navigationOptions = computed(() => {
      return windowWidth.value <= 1323;
    });

    return {
      searchQuery,
      placeholderText,
      redirectToSearch,
      navigationOptions,
    };
  },
};
</script>

<style scoped>
.tit {
  font-family: "Cairo";
}
</style>
